import React from 'react';
import { Typography, Stack, Grid } from '@mui/material';
import VariationPanel from './VariationPanel';
import MicroContentDetails from './MicroContentDetails';

export default function MicroContentViewPanel({ mx, variation, microContent, collapse }) {
    return (
        <Grid container spacing={2} flex="1">
            <Grid item xs={4}>
                <MicroContentDetails microContent={microContent} />
            </Grid>
            <Grid item xs={8}>
                <Stack direction="column" display="flex" justifyItems="center">
                    <Typography>{variation.displayName}</Typography>
                    <hr />
                    <VariationPanel microContent={microContent} variation={variation} />
                </Stack>
            </Grid>
        </Grid>
    );
}
